import { createContext, useContext, useEffect, ReactNode } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useAuth } from '@/hooks/useAuth';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

interface AnalyticsContextType {
  trackEvent: (eventType: string, metadata?: Record<string, unknown>) => Promise<void>;
}

const AnalyticsContext = createContext<AnalyticsContextType>({ trackEvent: async () => {} });

export const useTrackEvent = () => useContext(AnalyticsContext);

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  const { trackEvent } = useAnalytics();
  const { isAdmin, loading } = useAuth();

  // Stop Clarity recording for admin users
  useEffect(() => {
    if (loading) return;
    if (isAdmin && window.clarity) {
      window.clarity('stop');
    }
  }, [isAdmin, loading]);

  // REMOVED: Omnisend page view tracking per route change
  // Page views without email are skipped by Omnisend anyway,
  // and the Omnisend JS snippet handles anonymous page tracking.

  return (
    <AnalyticsContext.Provider value={{ trackEvent }}>
      {children}
    </AnalyticsContext.Provider>
  );
}
